import {DataGrid} from "@mui/x-data-grid";
import {useMemo, useState} from "react";
import {useLocalStorage} from "../../hooks/useLocalStorage";
import {useReps} from "../../hooks/useReps";
import {disableSortingAndMenu} from "../../util/FilterOperatorsUtil";
import {Grid, Typography} from "@mui/material";

const FacilityUsersTable = ({facilityId, businessUnitCode}) => {
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 20,
    });
    const [columnWidths, setColumnWidths] = useLocalStorage("facilityUsersTableColumnWidths", {});

    const columns = useMemo(() => {
        let header = [
            {field: "id", headerName: "ID", width: columnWidths?.id ?? 80},
            {field: "firstName", headerName: "FIRST NAME", width: columnWidths?.firstName ?? 110},
            {field: "lastName", headerName: "LAST NAME", width: columnWidths?.lastName ?? 110},
            {field: "email", headerName: "EMAIL", width: columnWidths?.email ?? 290},
            {
                field: "lastLoginDate",
                headerName: "LAST LOGIN DATE",
                valueFormatter: (value) => {
                    return value ? new Date(value).toLocaleString() : "Never";
                },
                width: columnWidths?.email ?? 180,
            },
        ];
        disableSortingAndMenu(header);
        return header;
    }, []);

    const [reps, totalRowCount, refetchReps] = useReps(
        businessUnitCode,
        null,
        null,
        null,
        paginationModel.page,
        paginationModel.pageSize,
        true,
        "",
        facilityId
    );
    const handleColumnResize = (params) => {
        setColumnWidths((prevWidths) => ({
            ...prevWidths,
            [params.colDef.field]: params.width,
        }));
    };
    if (reps?.length == 0) {
        return <></>;
    }
    return (
        <Grid item my={1} sx={{width: "100%"}}>
            <Typography sx={{fontWeight: "bold", fontSize: 16}} mb={1}>
                USERS
            </Typography>
            <DataGrid
                columns={columns}
                rows={reps}
                paginationMode="server"
                rowCount={totalRowCount}
                pageSizeOptions={[10, 20, 50]}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                slotProps={{
                    toolbar: {
                        csvOptions: {disableToolbarButton: true},
                        printOptions: {disableToolbarButton: true},
                        showQuickFilter: false,
                    },
                }}
                disableRowSelectionOnClick={true}
                onColumnWidthChange={handleColumnResize}
                sx={{
                    width: "100%",
                    "& .MuiDataGrid-cell:focus": {
                        outline: "none",
                    },
                    "& .MuiDataGrid-cell:focus-within": {
                        outline: "none",
                    },
                    "& .MuiDataGrid-row": {
                        cursor: "pointer",
                    },
                }}
            />
        </Grid>
    );
};

export default FacilityUsersTable;
